import { PartnerFeatureFlagKey } from '@portals/types';

enum CategoryNames {
  Common = 'Common',
  Release = 'Release',
}

export const FEATURE_LIST: Array<{
  id: PartnerFeatureFlagKey;
  label: string;
  category: CategoryNames;
}> = [
  {
    id: 'portal_config',
    label: 'Portal Config',
    category: CategoryNames.Common,
  },
  {
    id: 'customer_management',
    label: 'Customer Management',
    category: CategoryNames.Common,
  },
  { id: 'finance', label: 'Finance', category: CategoryNames.Common },
  { id: 'ansa', label: 'Ansa', category: CategoryNames.Common },
  { id: 'volvo_demo', label: 'Volvo Demo', category: CategoryNames.Common },
  { id: 'home', label: 'Home', category: CategoryNames.Common },
  { id: 'partners', label: 'Partners', category: CategoryNames.Common },
  {
    id: 'navigation_menu_design',
    label: 'Navigation Menu Design',
    category: CategoryNames.Common,
  },
  {
    id: 'credit_providers',
    label: 'Credit Providers',
    category: CategoryNames.Common,
  },
  {
    id: 'usage_based_pricing',
    label: 'Usage based pricing',
    category: CategoryNames.Common,
  },
  {
    id: 'enable_all_product_types',
    label: 'Enable all product types',
    category: CategoryNames.Common,
  },
  {
    id: 'integrations_demo',
    label: 'Integrations',
    category: CategoryNames.Common,
  },
  {
    id: 'infocom_publish_partner',
    label: 'Infocom Publish Partner',
    category: CategoryNames.Common,
  },
  {
    id: 'ticket_insight_demo',
    label: 'Ticket insight demo',
    category: CategoryNames.Common,
  },
  {
    id: 'orders_csv_export',
    label: 'Enable Orders CSV Export',
    category: CategoryNames.Common,
  },
  {
    id: 'ppp',
    label: 'Post purchase params',
    category: CategoryNames.Common,
  },
  {
    id: 'personalized_pricing_model',
    label: 'Personalized pricing model',
    category: CategoryNames.Common,
  },
  {
    id: 'organization_b2c_view',
    label: 'B2C View',
    category: CategoryNames.Common,
  },
  {
    id: 'store_branding_colors',
    label: 'Store branding colors',
    category: CategoryNames.Release,
  },
  {
    id: 'custom_from_email',
    label: 'Custom From Email',
    category: CategoryNames.Release,
  },
];
